import { Tooltip } from '@systemeio/ui'
import { ContactInterface } from 'modules/contacts/types/contact-interface'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { BlockedIcon, MutedIcon, StoppedIcon, TimeIcon } from '@systemeio/ui'

const ContactStatus = ({ contact }: { contact: ContactInterface }) => {
  const { t } = useLocoTranslation()
  return (
    <div className={'flex gap-1.5'}>
      {contact.unsubscribedFromTransactionalEmails && (
        <Tooltip
          mode={'hover'}
          label={t('dashboard.contacts.unsubscribed_from_transactional_emails')}
        >
          <BlockedIcon className={'main-transition-colors hover:fill-danger'} />
        </Tooltip>
      )}
      {contact.unsubscribed && (
        <Tooltip mode={'hover'} label={t('dashboard.contacts.contact_silence')}>
          <MutedIcon className={'main-transition-colors hover:fill-danger'} />
        </Tooltip>
      )}
      {contact.bounced && contact.bounceReason !== null && (
        <Tooltip
          mode={'hover'}
          label={t('dashboard.contacts.contact_bounce', { reason: contact.bounceReason })}
        >
          <StoppedIcon className={'main-transition-colors hover:fill-danger'} />
        </Tooltip>
      )}
      {contact.needConfirmation && (
        <Tooltip mode={'hover'} label={t('dashboard.contacts.not_confirmed')}>
          <TimeIcon className={'main-transition-colors hover:fill-danger'} />
        </Tooltip>
      )}
    </div>
  )
}

export default ContactStatus
